/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Name_RequiredInputs */

const en_us2_group_name_required = /** @type {(inputs: Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give the group a name.`)
};

const pt_br2_group_name_required = /** @type {(inputs: Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dê um nome à turma.`)
};

const pt_pt2_group_name_required = /** @type {(inputs: Group_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dê um nome à turma.`)
};

/** @type {(inputs: Group_Name_RequiredInputs) => LocalizedString} */
const es_419_group_name_required = en_us2_group_name_required;

/** @type {(inputs: Group_Name_RequiredInputs) => LocalizedString} */
const fr_fr2_group_name_required = en_us2_group_name_required;

/** @type {(inputs: Group_Name_RequiredInputs) => LocalizedString} */
const de_de2_group_name_required = en_us2_group_name_required;

/** @type {(inputs: Group_Name_RequiredInputs) => LocalizedString} */
const it_it2_group_name_required = en_us2_group_name_required;

/**
* | output |
* | --- |
* | "Give the group a name." |
*
* @param {Group_Name_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_name_required = /** @type {((inputs?: Group_Name_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Name_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_name_required(inputs)
	if (locale === "es-419") return es_419_group_name_required(inputs)
	if (locale === "pt-PT") return pt_pt2_group_name_required(inputs)
	if (locale === "fr-FR") return fr_fr2_group_name_required(inputs)
	if (locale === "de-DE") return de_de2_group_name_required(inputs)
	if (locale === "it-IT") return it_it2_group_name_required(inputs)
	return en_us2_group_name_required(inputs)
});
export { group_name_required as "group.name_required" }